import React, { useState } from 'react';
import ReplayIcon from '@material-ui/icons/Replay';
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline';
import PauseCircleOutlineIcon from '@material-ui/icons/PauseCircleOutline';

export const PlayAudioControl = ({ onPlay, onPause, audioEnded }) => {
  const [playing, setPlaying] = useState(true);

  const play = () => {
    setPlaying(true);
    onPlay();
  };

  const pause = () => {
    setPlaying(false);
    onPause();
  };

  ///////////////////////////////////////////////////
  // if (audioEnded) {
  //   return (
  //     <ReplayIcon
  //       style={{ color: 'white', opacity: '0.5', fontSize: '160px' }}
  //       onClick={play}
  //     />
  //   );
  // }

  if (playing) {
    return (
      <PauseCircleOutlineIcon
        style={{ color: 'white', opacity: '0.5', fontSize: '160px' }}
        onClick={pause}
      />
    );
  }

  return (
    <PlayCircleOutlineIcon
      style={{ color: 'white', opacity: '0.5', fontSize: '160px' }}
      onClick={play}
    />
  );
};

export default PlayAudioControl;
